<template>
  <div id="app">
<!--    <nav-bar></nav-bar>-->
    <router-view></router-view>
<!--    <footer-component></footer-component>-->
  </div>
</template>

<script>
// import NavBar from '@/components/NavBar.vue'
// import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    // NavBar,
    // 'footer-component': Footer
  }
}
</script>

<style>
html {
  scroll-behavior: smooth; /* 实现平滑滚动 */
  width: 100vw;
  overflow: hidden;
  overflow-y: auto;
}
#app {
  font-family: 'Arial', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  padding: 0;
}

h1, h2, h3, h4, h5, h6 {
  color: #fff;
  margin: 0;
  padding: 0;
}

.gradient-text {
  background: linear-gradient(to right, #c8a97e, #f4e4bc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.el-menu {
  border: none !important;
  background-color: transparent !important;
}

.el-menu--horizontal > .el-menu-item {
  color: #fff !important;
}

.el-menu--horizontal > .el-menu-item.is-active {
  color: #c8a97e !important;
  border-bottom-color: #c8a97e !important;
}
</style> 